// Crop a canvas to the bounding box of its non-transparent pixels, so a generated
// (Auto-Fill) signature has no whitespace padding and fills its slot once placement
// scales it to the capped height (mirrors the drawn path's getTrimmedCanvas()).
export const trimCanvas = (canvas) => {
  const ctx = canvas.getContext('2d')
  const { width, height } = canvas
  const { data } = ctx.getImageData(0, 0, width, height)
  let top = null, bottom = null, left = null, right = null
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      if (data[(y * width + x) * 4 + 3] !== 0) {
        if (top === null) top = y
        bottom = y
        if (left === null || x < left) left = x
        if (right === null || x > right) right = x
      }
    }
  }
  if (top === null) return canvas
  const w = right - left + 1
  const h = bottom - top + 1
  const trimmed = document.createElement('canvas')
  trimmed.width = w
  trimmed.height = h
  trimmed.getContext('2d').drawImage(canvas, left, top, w, h, 0, 0, w, h)
  return trimmed
}

// Render a name in the signature font as a trimmed PNG data URL.
export const generateSignatureImage = async (fullName) => {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  canvas.width = 600
  canvas.height = 150

  const fontSize = fullName.length > 20 ? 52 : 72
  await document.fonts.load(`${fontSize}px Hugesnow`)
  ctx.clearRect(0, 0, canvas.width, canvas.height)
  ctx.font = `${fontSize}px Hugesnow`
  ctx.fillStyle = '#000'
  ctx.textBaseline = 'middle'
  ctx.textAlign = 'left'

  ctx.fillText(fullName, 20, canvas.height * 0.65)

  return trimCanvas(canvas).toDataURL('image/png')
}
